// publicRoutes
export const LOGIN_ROUTE = "/";

// privateRoutes
export const MAIN_ROUTE = "/*";
